import { Box, Typography } from "@mui/material"

import React from "react"
import { TicketCard } from "react-ui-components/components/raffle/TicketCard"

/**
 * Live preview of a raffle ticket as it will actually render for end users.
 * Reuses the same TicketCard the web app renders, so the admin preview and
 * the production ticket can never visually drift apart.
 */
const TicketPreview = ({ design }: { design: any }) => {
  return (
    <Box className="flex flex-col items-center gap-2">
      <Typography variant="caption" color="text.secondary">
        Live preview (as seen by users)
      </Typography>
      <TicketCard
        design={design}
        ticketImage={typeof design?.ticketImage === "string" ? design.ticketImage : undefined}
        code="ABC123"
        dateLabel="01/01/2026"
        raffleTypeLabel="Sample Raffle"
      />
    </Box>
  )
}

export default TicketPreview
